import { Component, Input, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService, MenuItem } from 'primeng/api';
import { AppDataService, PromosService } from 'app/services';
import { PromoTypeEnum } from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'partner-marketing-promotions',
    templateUrl: './partner-marketing-promotions.component.html',
    styleUrls: ['./partner-marketing-promotions.component.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerMarketingPromotionsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    public isMerchant: boolean = false;
    public merchantId: number = 0;

    //---------------Promos----------------------
    public promos: any = null;
    public promoCols: any[] = [
        { field: 'Id', header: 'Promo ID', width: '20%' },
        { field: 'PromoTypeText', header: 'Promo Type', width: '20%' },
        { field: 'Code', header: 'Promo Host', width: '20%' },
        { field: 'Name', header: 'Promo Name', width: '20%' },
        { field: 'UseAmount', header: 'Dis. Value', width: '20%' },
        { field: 'MinSpend', header: 'Min Spend', width: '20%' },
        { field: 'StartedAt', header: 'Start', width: '20%' },
        { field: 'ValidUntil', header: 'End', width: '20%' },
        { field: 'PromoAvailableText', header: 'Customers', width: '20%' },
        { field: 'MaxUseCount', header: 'Max Redm.', width: '20%' },
        { field: 'IsActive', header: 'Status', width: '20%' }
    ];
    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };
    private searchTimer: number = 0;

    public loading: boolean = false;

    public showAddEditPromotionSideBar: boolean = false;
    public visiblePartnerMarketingFilterPromotion: boolean = false;
    public filterObj: any = {};

    public selectPromoId: number = 0;
    public selectPromoTypeId!: PromoTypeEnum;

    constructor(private messageService: MessageService, public appData: AppDataService,
        public promosService: PromosService){
        this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        this.isMerchant = this.appData.isMerchant();
    }

    ngOnInit(): void {
    }

    public handlePromoLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getMerchantPromos(skip, this.filterObj);
    }
    public getMerchantPromos(skip: number, filterObj: any) {
        this.filterObj = filterObj;

        const dto = {
            MerchantId: this.merchantId,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            SearchName: this.filter.searchName,
            PromoTypeId: this.filterObj.PromoTypeId,
            StartedAt: this.filterObj.StartedAt,
            ValidUntil: this.filterObj.ValidUntil,
            IsActive: this.getFilterStatus(this.filterObj.Status),
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.loading = true;

        this.promosService.getMerchantPromos(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.promos = data.Items;
                if (data.Items !== null) {
                    this.promos = data.Items.map((x: any) => {
                        x.UseAmount = '₱ ' + x.UseAmount;
                        x.StartedAt = moment(x.StartedAt).format('MMM Do YY');
                        x.ValidUntil = moment(x.ValidUntil).format('MMM Do YY');
                        x.MinSpend = '₱ ' + x.MinSpend;
                        return x;
                    });
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public getFilterStatus(status: string) {
        if (status === 'Active') {
            return true;
        }
        else if (status === 'Inactive') {
            return false;
        }
        return null;
    }

    public updateMerchantPromoIsActive(promo: any) {
        const dto = {
            PromoId: promo.Id,
            IsActive: promo.IsActive
        };

        this.promosService.updateMerchantPromoIsActive(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data update success' });
            });

    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchantPromos(0, this.filterObj);
            this.searchTimer = 0;
        }, 1500);
    }

    public switchPromo(promo: any) {
        this.updateMerchantPromoIsActive(promo);
    }

    public openMerchantCreatePromotionSideBar() {
        this.showAddEditPromotionSideBar = true;
    }
    changedShowAddEditPromotionSideBarEmit(value: any) {
        this.showAddEditPromotionSideBar = value;
        this.selectPromoId = 0;
        this.selectPromoTypeId = 0;
    }

    public openMerchanteditPromotionSideBar(promoId: number, promoTypeId: PromoTypeEnum) {
        this.selectPromoId = promoId;
        this.selectPromoTypeId = promoTypeId;
        this.showAddEditPromotionSideBar = true;
    }

    public openPartnerMarketingFilterPromotionSideBar() {
        this.visiblePartnerMarketingFilterPromotion = true;
    }
    changedShowPartnerMarketingFilterPromotionSideBarEmit(value: boolean) {
        this.visiblePartnerMarketingFilterPromotion = value;
    }
}
